import { ref } from 'vue'
export const agency = ref({
    userAccount:'', 
    current:'', //teamReports teamOrderRecords teamAccountRecords
    teamAccountRecordsType:'' // transactionRecord rechargeRrecord withdrawalRecords
})